export const lead_handler = (key, value, obj) => ({
    type: 'LEAD_HANDLER', key, value, obj,
});
export const edit_field = (status, index) => ({ type: 'EDIT_FIELD', status, index });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/lead_handler.actions.js